import { Device } from '@cardsjd/device';

import '@sagi.io/globalthis';

import AdProvider_Facebook from './AdProvider/AdProvider_Facebook.js';
import AdProvider_GoogleH5 from './AdProvider/AdProvider_GoogleH5.js';
import CapacitorAdmob from './AdProvider/CapacitorAdmob.js';

export default class Advertisement {
	constructor(config) {
		this.config = config;
		this.removeAds = false;
		this.lastShownInterstitial = null;
		this.lastShownRewarded = null;
		this.onAdRewarded = null;
		this.onAdLoaded = null;
		this.onAdOpened = null;
		this.onAdError = null;
		this.adProvider = null;
	}

	async setUp() {
		const config = this.config;

		//setup only once, there are event that get wired up
		if (this.isSetup) {
			return;
		}

		this.isSetup = true;

		//chose provider and ad ids based on OS 
		const os = this.getPlatform();

		switch (os) {
			case 'android':
				this.adProvider = new CapacitorAdmob(
					{
						appId: config.admobAppId_Android,
						interstitialAdId: config.admobInterstitialAdId_Android,
						rewardedAdId: config.admobRewardedAdId_Android,
						appOpenAdId: config.admobAppOpenAdId_Android,
						onAdLoaded: this.adLoaded.bind(this),
						onAdOpened: this.adOpened.bind(this),
						onAdClosed: this.adClosed.bind(this),
						onAdError: this.adError.bind(this),
					},
				);
				break;
			case 'ios':
				if (typeof globalThis.device !== 'undefined' && globalThis.device.version?.startsWith('12')) {
					console.log(`ios 12 has a bug - can not click ad; Skip showing ad`);

				} else {
					this.adProvider = new CapacitorAdmob(
						{
							appId: config.admobAppId_iOS,
							interstitialAdId: config.admobInterstitialAdId_iOS,
							rewardedAdId: config.admobRewardedAdId_iOS,
							appOpenAdId: config.admobAppOpenAdId_iOS,
							onAdLoaded: this.adLoaded.bind(this),
							onAdOpened: this.adOpened.bind(this),
							onAdClosed: this.adClosed.bind(this),
							onAdError: this.adError.bind(this),
						},
					);

				}

				break;
			case 'FBInstant':
				this.adProvider = new AdProvider_Facebook({
					interstitialAdId: config.facebookAdId_interstital,
					rewardedAdId: config.facebookAdId_reward,
					onAdLoaded: this.adLoaded.bind(this),
					onAdOpened: this.adOpened.bind(this),
					onAdClosed: this.adClosed.bind(this),
					onAdError: this.adError.bind(this),
				});
				break;
			case 'web':
			case 'windows':
			case 'windowsPWA':
				this.adProvider = new AdProvider_GoogleH5({
					appId: config.googleH5_ad_client,
					interstitialAdId: config.googleH5_ad_channel,
					onAdLoaded: this.adLoaded.bind(this),
					onAdOpened: this.adOpened.bind(this),
					onAdClosed: this.adClosed.bind(this),
					onAdError: this.adError.bind(this),
				});
				break;
		}

		if (this.adProvider) {
			await this.adProvider.setup();
		} else {
			//todo: default to admob and let admob figure out if it is ios or android
			this.removeAds = true;
			this.isSetup = true;
			console.log(os + ' platform is not supported'); return;
		}

	}

	tryShowInterstitialAd() {
		const config = this.config;
		//0. if ads removed, dont even load the ad
		//1. only allow ad to be shown/loaded once every 150 second (Advertisement.delayBetweenAds)
		//2. check if over 20 min, may have not been in the app and reopened it with out restarting 
		//3. load ad ether way
		//4. show ad if conditions met

		//only load/show if ads enabled
		if (this.removeAds) {
			return;
		}

		let readyToShowAd = false;

		//reset timer
		if (this.lastShownInterstitial === null) {
			this.lastShownInterstitial = Date.now();//now
			//add start offset delay
			const newDate = new Date();
			newDate.setSeconds(newDate.getSeconds() - config.offsetStartdelay);
			this.lastShownInterstitial = newDate;
		}

		const secondsSinceLastAd = (Date.now() - this.lastShownInterstitial) / 1000;

		//check for  delayBetweenAds seconds passed
		if (secondsSinceLastAd > config.delayBetweenAds) {
			readyToShowAd = true;
		}

		//check if over 20 min, may have not been in the app and reopened it with out restarting 
		if (secondsSinceLastAd > config.awayResetTime) {
			readyToShowAd = false;
			this.lastShownInterstitial = Date.now();//now, reset
		}

		console.log('readyToShowInterstitialAd: ' + readyToShowAd + ' : ' + secondsSinceLastAd + ' of ' + config.delayBetweenAds);

		// show ad or just load ad
		if (readyToShowAd) {
			this.showInterstitialAd();
		} else {
			this.loadInterstitialAd();
		}
	}

	loadInterstitialAd(forceShow) {
		if (this.adProvider) {
			this.adProvider.loadAd(forceShow);
		}
	}

	showInterstitialAd() {
		if (this.adProvider) {
			this.adProvider.showAd();
		}
	}

	tryLoadRewardedAd() {
		const config = this.config;
		//1. allow first load to start after 0 minute 
		//2. allow rewarded ad to be shown/loaded once every 60000 (10 min)

		// //only load/show if ads enabled
		// if (this.removeAds) return;
		let readyToLoadAd = false;

		//allow no last time found - set date back a day
		if (this.lastShownRewarded === null) {
			this.lastShownRewarded = new Date().setTime(Date.now() - 86400000); //1 days = 86400000 ;
		}

		//check for 60000 seconds passed 
		const secondsSinceLastRewardedAd = (Date.now() - this.lastShownRewarded) / 1000;

		if (secondsSinceLastRewardedAd > config.delayBetweenRewardedAds) {
			readyToLoadAd = true;
		}

		console.log('readyToShowRewardedAd: ' + readyToLoadAd + ' : ' + secondsSinceLastRewardedAd + ' of ' + config.delayBetweenRewardedAds);

		if (readyToLoadAd) {
			this.loadRewardedAd();
		}
	}

	loadRewardedAd() {
		if (this.adProvider) {
			this.adProvider.loadRewardedAd();
		}
	}

	showRewardedAd() {
		if (this.adProvider) {
			this.adProvider.showRewardedAd();
		}
	}

	showAppOpenAd() {
		if (this.adProvider) {
			return this.adProvider.showAppOpenAd();
		}
	}

	async showAppOpenAdWithMaxDelay(maxDelay) {
		if (!maxDelay) {
			maxDelay = 4000;
		}

		let timeoutPromise = null;

		if (this.removeAds) {
			return;
		}

		if (typeof this.adProvider?.showAppOpenAd === 'function') {
			timeoutPromise = new Promise((_resolve, reject) => {
				setTimeout(() => {
					//stop ad from showing
					if (this.adProvider) {
						this.adProvider.appOpenAdAutoShow = false;
					}

					reject(new Error('showAppOpenAd has not fired after 4 seconds. Skipping ad'));
				}, maxDelay);
			});
			await Promise.race([timeoutPromise, this.adProvider.showAppOpenAd()]);
			clearTimeout(timeoutPromise);
		} else {
			throw new Error('Ad Provider not enabled');
		}
	}

	showMediationTestSuite() {
		if (this.adProvider) {
			this.adProvider.showMediationTestSuite();
		}
	}

	showAdInspector() {
		if (this.adProvider) {
			this.adProvider.showAdInspector();
		}
	}

	isInterstitialAdLoaded() {
		if (!this.adProvider) {
			return false;
		}

		return this.adProvider.isAdLoaded();
	}

	isAppOpenAdLoaded() {
		if (!this.adProvider) {
			return false;
		}

		return this.adProvider.isAppOpenAdLoaded();
	}

	adLoaded(data) {
		//only allow rewarded ad to be loaded once per timer
		if (data && data.adType === 'rewarded') {
			this.lastShownRewarded = Date.now();
		}
	}

	adOpened(data) {
		if (data && data.adType === 'interstitial') {
			this.lastShownInterstitial = Date.now(); //reset interstitial timer for either ad
		}

		if (data && data.adType === 'rewarded') {
			this.lastShownInterstitial = Date.now(); //reset interstitial timer for either ad
			this.lastShownRewarded = Date.now();
		}
	}

	adClosed(data) {
		if (data && data.adType === 'interstitial') {
			this.lastShownInterstitial = Date.now(); //reset interstitial timer for either ad
		}

		if (data && data.adType === 'rewarded') {
			this.lastShownInterstitial = Date.now(); //reset interstitial timer for either ad
			this.lastShownRewarded = Date.now();

			if (data.rewardAmount) {
				if (this.onAdRewarded) {
					this.onAdRewarded(data.rewardAmount, data.rewardType);
				}
			}
		}
	}

	adError(data) {
		if (this.onAdError) {
			this.onAdError(data.error, data.adType);
		}
	}

	getPlatform() {
		const device = new Device();
		return device.getPlatform();
	}
}
